import React from 'react';
import { ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';
import {
  DEFAULT_GOOGLE_MAP_LATITUDE,
  DEFAULT_GOOGLE_MAP_LONGITUDE,
  setMapCenter,
} from '@src/core/controllers';
import { AssignedHubsContentProps } from './types';
import { useDispatch } from 'react-redux';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const AssignedHubsContent: React.FC<AssignedHubsContentProps> = (props) => {
  const { profile, isLoading } = props;

  const dispatch = useDispatch();

  const lat = Number(profile?.hub?.latitude);
  const lng = Number(profile?.hub?.longitude);

  React.useEffect(() => {
    dispatch(
      setMapCenter({
        lat: isNaN(lat) ? DEFAULT_GOOGLE_MAP_LATITUDE : lat,
        lng: isNaN(lng) ? DEFAULT_GOOGLE_MAP_LONGITUDE : lng,
      })
    );
  }, [dispatch, lat, lng]);

  if (isLoading) return <ArcSkeleton height={300} />;

  return (
    <ArcStack p={3} spacing={2.5} borderRadius={1} bgcolor='background.paper'>
      <ArcStack spacing={0.6}>
        <ArcText.h3 fontSize={16}>Assigned Hubs</ArcText.h3>
        <ArcText.caption fontSize={14}>Operational hubs this account is linked to</ArcText.caption>
      </ArcStack>

      <ArcStack  spacing={1}>
        {profile?.hubs?.map((hub) => (
          <ArcStack key={hub.id} sx={{ border: '0.5px solid', borderColor: 'divider', borderRadius: 1, padding: '10px 16px'}}>
            <ArcText.h4 fontSize={14}>{hub.name}</ArcText.h4>
            <ArcStack direction='row' spacing={0.1} alignItems='center'>
              <LocationOnIcon sx={{color: 'text.secondary', fontSize: 12 }} />
              <ArcText.caption fontSize={12}>{hub.location}</ArcText.caption>
            </ArcStack>
          </ArcStack>
        ))}
      </ArcStack>
    </ArcStack>
  );
};

export default AssignedHubsContent;
